export default __webpack_public_path__ + "static/media/right_arrow.e16ce92b.svg";